import { FIRST_ELEMENT, SECOND_ELEMENT, EMPTY_STRING } from '@constants';
import { TimeSeriesChartData, CHART_TYPE, SequenceData } from '@customTypes';

export const convertSequenceDataToBarChartData = <T extends SequenceData, K extends keyof T>(
  data: [Array<T>, Array<T>],
  property: K,
  options: {
    categories: [string, string];
    yAxisTitle: string;
  },
): TimeSeriesChartData => {
  const series = [
    {
      name: options.categories[FIRST_ELEMENT],
      type: CHART_TYPE.BAR,
      data: data[FIRST_ELEMENT].map((record) => Number(record[property])),
    },
    {
      name: options.categories[SECOND_ELEMENT],
      type: CHART_TYPE.BAR,
      data: data[SECOND_ELEMENT].map((record) => Number(record[property])),
    },
  ];

  return {
    type: CHART_TYPE.BAR,
    title: EMPTY_STRING,
    xaxis: {
      title: null,
      categories: data[FIRST_ELEMENT].map((record) => record.name),
    },
    yaxis: {
      title: options.yAxisTitle,
      categories: null,
    },
    series,
  };
};
